import { AfterViewInit, Component, Input, OnInit, ViewChild } from '@angular/core';
import { FileUploadService } from '../../services/file-upload.service';
import { LoginService } from '../../services/login.service';
import { Observable } from 'rxjs/Observable';
import { UploadFileInformation } from '../../data-objects/upload-file-information';
import { FileUpload } from 'primeng/primeng';
import { UploadfilesViewmodel } from '../../viewmodels/uploadfiles-viewmodel';
import { FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-upload-file',
  templateUrl: './upload-file.component.html',
  styleUrls: ['./upload-file.component.css'],
  entryComponents: [FileUpload]
})
export class UploadFileComponent implements OnInit, AfterViewInit {

  @Input() uploadfilesViewmodel?: UploadfilesViewmodel;
  @Input() uploadfilesViewModelSecondInstance?: UploadfilesViewmodel;

  @Input() controlLabel: string;
  @Input() isLand = false;
  @Input() instance: number = 0;

  @ViewChild('fileUpload') fileUpload: FileUpload;
  @ViewChild('fileUploadSecondInstance') fileUploadSecondInstance: FileUpload;

  fileControl: FormControl;
  dropboxControl: FormControl;
  dropboxUrlControl: FormControl;

  fileControl_secondInstance: FormControl;
  dropboxControl_secondInstance: FormControl;
  dropboxUrlControl_secondInstance: FormControl;

  uploadControl: FormControl;
  dropboxControlLength = 255;

  submitErrorMessage: string;
  submitErrorMessage_secondInstance: string;

  constructor(private loginService: LoginService, private fileUploadService: FileUploadService) {
    const reg: any = '(http(s)?://)?([\\w-]+\\.)+[\\w-]+[.com]+(/[/?%&=]*)?';

    this.uploadControl = new FormControl();

    this.fileControl = new FormControl();
    this.fileControl_secondInstance = new FormControl();

    this.dropboxControl = new FormControl();
    this.dropboxControl_secondInstance = new FormControl();

    this.dropboxUrlControl = new FormControl('', [Validators.maxLength(this.dropboxControlLength), Validators.pattern(reg)]);
    this.dropboxUrlControl_secondInstance = new FormControl('', [Validators.maxLength(this.dropboxControlLength), Validators.pattern(reg)]);
  }

  ngAfterViewInit(): void {
    if (this.uploadfilesViewmodel) {
      if (!this.uploadfilesViewmodel.isDropbox && this.uploadfilesViewmodel.files && this.uploadfilesViewmodel.files.length > 0) {
        this.doAddFiles(this.uploadfilesViewmodel.files);
        this.fileUpload.customUpload = true;
        this.fileUpload.files = this.uploadfilesViewmodel.files;
        this.fileUpload.upload();
      } else if (this.uploadfilesViewmodel.isDropbox) {
        this.fileUpload.files = [];
      }
    }

    if (this.uploadfilesViewModelSecondInstance) {
      if (!this.uploadfilesViewModelSecondInstance.isDropbox && this.uploadfilesViewModelSecondInstance.files && this.uploadfilesViewModelSecondInstance.files.length > 0) {
        this.doAddFiles(this.uploadfilesViewModelSecondInstance.files);
        this.fileUploadSecondInstance.customUpload = true;
        this.fileUploadSecondInstance.files = this.uploadfilesViewModelSecondInstance.files;
        this.fileUploadSecondInstance.upload();
      } else if (this.uploadfilesViewModelSecondInstance.isDropbox) {
        this.fileUploadSecondInstance.files = [];
      }
    }
  }

  ngOnInit() {
    this.submitErrorMessage = null;
    this.submitErrorMessage_secondInstance = null;
  }

  addFiles(event: any, instance: number = 0): boolean {
    return this.doAddFiles(event.files, instance);
  }

  doAddFiles(files, instance: number = 0): boolean {
    this.submitErrorMessage = null;
    this.submitErrorMessage_secondInstance = null;


    let regexpNumber = new RegExp('^([a-zA-Z0-9-_\\s])+(.pdf|.PDF|.dwg|.dxf|.dgn)$');
    //this.uploadfilesViewmodel.files = files; // puts all files into an array

    let validFiles = [];
    let submitErrorMessages = [];
    // call them as such; files[0].size will get you the file size of the 0th file
    //for (let i = 0; i < this.uploadfilesViewmodel.files.length; i++) {
    if (files) {
      for (let i = 0; i < files.length; i++) {
        if (!regexpNumber.test(files[i].name.toLowerCase())) {
          //this.uploadfilesViewmodel.files.splice(i, 1);
          //this.submitErrorMessage = `File Name: ${this.uploadfilesViewmodel.files[i].name}<br/>File name can contain only alpha-numeric characters, spaces, underscores and dashes.`;
          //return false;
          submitErrorMessages.push(`<strong>[ERROR]</strong> ${files[i].name}<br/><strong>File name can contain only alpha-numeric characters, spaces, underscores and dashes.</strong>`);
          continue;
        }

        if (files[i].name.length > 100) {
          //this.uploadfilesViewmodel.files.splice(i, 1);
          //this.submitErrorMessage = `File Name: ${this.uploadfilesViewmodel.files[i].name}<br/>File name can contain only alpha-numeric characters, spaces, underscores and dashes.`;
          //return false;
          submitErrorMessages.push(`<strong>[ERROR]</strong> ${files[i].name}<br/><strong>The length of file name must be less than 100 characters.</strong>`);
          continue;
        }

        const fileSize: number = Number(((files[i].size / 1024) / 1024).toFixed(4)); // MB
        if (files[i].name !== 'item'
          && typeof files[i].name !== 'undefined'
          && fileSize > 20) {
          //this.uploadfilesViewmodel.files.splice(i, 1);
          //this.submitErrorMessage = 'Please limit individual files size to 20MB and ensure files are in a PDF format.';
          submitErrorMessages.push(`<strong>[ERROR]</strong> ${files[i].name}<br/><strong>Please limit individual files size to 20MB and ensure files are in a PDF format.</strong>`);
          //return false;
          continue;
        }

        validFiles.push(files[i]);
      }
    }

    this.uploadfilesViewmodel.files = validFiles;

    if (instance === 0) {
      this.submitErrorMessage = submitErrorMessages.length > 0 ? submitErrorMessages.join('<br/><br/>') : '';
      this.fileUploadService.addFile(this.uploadfilesViewmodel.files, false);
      this.fileUpload.files = this.uploadfilesViewmodel.files;
    }

    if (instance === 1) {
      this.submitErrorMessage_secondInstance = submitErrorMessages.length > 0 ? submitErrorMessages.join('<br/><br/>') : '';
      this.fileUploadService.addFile(this.uploadfilesViewmodel.files, true);
      this.fileUploadSecondInstance.files = this.uploadfilesViewmodel.files;
    }

    return (this.uploadfilesViewmodel.files.length > 0);
  }

  clearFiles(): void {
    this.uploadfilesViewmodel.dropboxUrl = '';
    this.uploadfilesViewmodel.isDropbox = false;

    // 1st instance
    this.fileUpload.files = [];
    this.submitErrorMessage = null;

    // 2nd instance
    this.fileUploadSecondInstance.files = [];
    this.submitErrorMessage_secondInstance = null;
  }

  uploadFiles(isSecondInstance: boolean = false): Observable<string[]> {
    return this.fileUploadService.uploadFile(this.loginService.getToken(), isSecondInstance);
  }

  updateFileInformation(uploadFileInfo: UploadFileInformation): Observable<boolean> {
    return this.fileUploadService.updateFileInformation(uploadFileInfo, this.loginService.getToken());
  }

  get isDropbox(): boolean {
    return this.uploadfilesViewmodel.isDropbox;
  }

  get dropboxUrl(): string {
    return this.uploadfilesViewmodel.dropboxUrl;
  }

  set dropboxUrl(v: string) {
    this.uploadfilesViewmodel.dropboxUrl = v;
  }

  get isValid(): boolean {
    this.submitErrorMessage = null;

    // if (!this.isDropbox && !this.fileUploadService.isValid()) {
    if (!this.isDropbox && (this.fileUpload.files && this.fileUpload.files.length === 0) ) {
      this.submitErrorMessage = 'Please upload file.';
      return false;
    } else if (this.isDropbox && this.uploadfilesViewmodel.dropboxUrl === '' && this.uploadfilesViewmodel.dropboxUrl.length === 0) {
      this.submitErrorMessage = 'Please enter drop box url.';
      return false;
    } else if (this.isDropbox && this.dropboxUrlControl.invalid) {
      this.submitErrorMessage = 'Please enter valid drop box url.';
      return false;
    }

    return true;
  }

  set isDropboxValue(v: string) {
    this.uploadfilesViewmodel.isDropboxValue = v;
    switch (v) {
      case 'file':
        this.uploadfilesViewmodel.isDropbox = false;
        this.dropboxUrlControl.disable();
        this.uploadControl.enable();
        break;
      case 'dropbox':
        this.uploadfilesViewmodel.isDropbox = true;
        this.dropboxUrlControl.enable();
        this.uploadControl.disable();
        break;
    }
  }

  get isDropboxValue(): string {
    return this.uploadfilesViewmodel.isDropboxValue;
  }


  // second instance
  get isDropbox_secondInstance(): boolean {
    return this.uploadfilesViewModelSecondInstance.isDropbox;
  }

  get dropboxUrl_secondInstance(): string {
    return this.uploadfilesViewModelSecondInstance.dropboxUrl;
  }

  set dropboxUrl_secondInstance(v: string) {
    this.uploadfilesViewModelSecondInstance.dropboxUrl = v;
  }

  get isValid_secondInstance(): boolean {
    this.submitErrorMessage_secondInstance = null;

    // if (!this.isDropbox_secondInstance && !this.fileUploadService.isValid()) {
    if (!this.isDropbox_secondInstance && (this.fileUploadSecondInstance.files && this.fileUploadSecondInstance.files.length === 0) ) {
      this.submitErrorMessage_secondInstance = 'Please upload file.';
      return false;
    } else if (this.isDropbox && this.uploadfilesViewModelSecondInstance.dropboxUrl === '' && this.uploadfilesViewModelSecondInstance.dropboxUrl.length === 0) {
      this.submitErrorMessage_secondInstance = 'Please enter drop box url.';
      return false;
    } else if (this.isDropbox_secondInstance && this.dropboxUrlControl.invalid) {
      this.submitErrorMessage_secondInstance = 'Please enter valid drop box url.';
      return false;
    }

    return true;
  }

  set isDropboxValue_secondInstance(v: string) {
    this.uploadfilesViewModelSecondInstance.isDropboxValue = v;
    switch (v) {
      case 'file':
        this.uploadfilesViewModelSecondInstance.isDropbox = false;
        this.dropboxUrlControl_secondInstance.disable();
        this.uploadControl.enable();
        break;
      case 'dropbox':
        this.uploadfilesViewModelSecondInstance.isDropbox = true;
        this.dropboxUrlControl_secondInstance.enable();
        this.uploadControl.disable();
        break;
    }
  }

  get isDropboxValue_secondInstance(): string {
    return this.uploadfilesViewModelSecondInstance.isDropboxValue;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/upload-file/upload-file.component.ts